"use strict";

// plugins
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { SwalMessage } from '../js/Tools.js'

import './DarkMode'
// import './View.js'
import './Currency'
import './Auth'
import './Sliders'
import './pages/product/Product'
import './pages/order/Order'
import './pages/FavoritesAndTrackingList'
import './pages/ProductQuestion'
import './pages/Assessment'
import './pages/profile/Profile'
import './pages/Support'
import './FormRequests'
import './CountryInfo'
import './pages/Checkoutv2.js'
import './pages/ShoppingCartv2.js'
import './pages/article.js'

const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

// ajax
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': csrfToken
    }
});
window.csrfToken = csrfToken;

!function () { if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) var n = jQuery.fn.select2.amd; n.define("select2/i18n/tr", [], function () { return { errorLoading: function () { return "Sonuç yüklenemedi" }, inputTooLong: function (n) { return n.input.length - n.maximum + " karakter daha girmelisiniz" }, inputTooShort: function (n) { return "En az " + (n.minimum - n.input.length) + " karakter daha girmelisiniz" }, loadingMore: function () { return "Daha fazla…" }, maximumSelected: function (n) { return "Sadece " + n.maximum + " seçim yapabilirsiniz" }, noResults: function () { return "Sonuç bulunamadı" }, searching: function () { return "Aranıyor…" }, removeAllItems: function () { return "Tüm öğeleri kaldır" } } }), n.define, n.require }();


// initial
var Init = function () {

    var Load = function () {
        console.log('Powered by Akita - Osman Yavuz');

        // tooltip
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))


    }

    // lazy olmayan img taglarına parametre ekleme
    var ImgLazyload = function () {
        var imgElements = document.querySelectorAll('img');
        imgElements.forEach(function (imgElement) {
            if (!imgElement.getAttribute('loading')) {
                imgElement.setAttribute('loading', 'lazy');
            }
        });
    }

    // select2 compenent
    var Select2Handle = function () {
        $('[data-type="select2"]').select2({
            // dropdownParent: $("#canvasShippings"),
            language: langCodeShort
        });
    }

    // mobil menü
    var MobilMenu = function () {
        const menu = document?.querySelector('#mobile-menu');

        if(!menu){
            return;
        }

        $(document).on('change', '#mobileMenuToggle', function (event) {
            event.preventDefault();

            if (menu.classList.contains('active')) {
                
                menu.classList.remove('active')
                menu.style.transform = 'translate(-114%, 0)';
            } else {
                menu.classList.add('active')
                menu.style.transform = 'translate(-10%, 0)';
            }
        });
        

        $(document).on('click', '#mobile-dropdown-menu-button', function (event) {
            event.preventDefault();
            const parentElement = $(event.target).parent();
            const dropdownMenu = parentElement.find('.mobile-dropdown-menu-list');

            if (dropdownMenu.hasClass('active')) {
                dropdownMenu.removeClass('active');
                dropdownMenu.hide();
              } else {
                dropdownMenu.addClass('active');
                dropdownMenu.show();
              }
        });

    }

    

    return {
        init: function () {
            Load();
            ImgLazyload();
            Select2Handle();
            MobilMenu();
        },
    };

}();

// bülten aboneliği
var Subscription = function () {
    $(document).on('click', '[data-subscription-submit]', function (event) {
        event.preventDefault();

        let form = event.target.closest('form')
        let button = this

        $.ajax({
            url: apiUrl + '/CreateUserSubscription',
            type: "POST",
            dataType: "json",
            data: $(form).serialize(),
            async: true,
            error: function error(xhr) {
                //console.log(xhr)
                SwalMessage(
                    {
                        type: 'error',
                        text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                        confirmButton: translate.ok_button,
                    },
                    function () {
                        location.reload();
                    }
                );
            },
            beforeSend: function () {
                button.setAttribute('disabled', '');
            },
            complete: function () {
                button.removeAttribute('disabled');
            },
            success: function success(xhr) {
                //console.log(xhr)
                SwalMessage(
                    {
                        type: 'success',
                        text: xhr.text ?? xhr.message,
                        confirmButton: translate.ok_button,
                    },
                    function () {
                        // location.reload();
                    }
                );
            }
        });


    })
}

// sidebar sticky
var SidebarStickyHandle = function () {
    var left;
    var Load = function () {

        var stop = (left.offsetTop - 200);

        window.onscroll = function (e) {
            var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            console.log(scrollTop, left.offsetTop);
            // left.offsetTop;

            if (scrollTop >= stop) {
                left.className = 'stick';
            } else {
                left.className = '';
            }

        }
    }

    return {
        init: function () {
            left = document.getElementById("sidebar-left");
            if (!left) {
                return;
            }
            Load();
        },
    };


}();

// galeri görselleri
var GalleryImages = function () {
    var Gallery = function () {


        const lightbox = GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: true
        });


    }

    return {
        init: function () {
            let container = document.querySelector('.gallery-images');
            if (container) {
                Gallery();
            }
        },
    };
}();

$(function () {

    Init.init();

    Subscription();

    SidebarStickyHandle.init();


    GalleryImages.init();


});





























